import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import HighlightedComponent from '~/widget/components/HighlightedComponent';
import ServiceList from '~/widget/components/ServiceList';
import useCopy from '~/widget/hooks/useCopy';
import useLocale from '~/widget/hooks/useLocale';
import usePathPrefix from '~/widget/hooks/usePathPrefix';
import useWidgetContext from '~/widget/hooks/useWidgetContext';
import useTracking from '~/widget/hooks/useTracking';

const IframeLanding: React.FC = ({}) => {
  const context = useWidgetContext();
  const pathPrefix = usePathPrefix();
  const { serviceList } = useCopy();
  const locale = useLocale();
  const { highlighted } = context;
  const doTrack = useTracking();

  useEffect(() => {
    doTrack({ name: 'wgt_app_list_loaded' });
  }, [doTrack]);

  return (
    <Main>
      <Helmet>
        <title>App Overzicht</title>
      </Helmet>
      <HighlightedComponent
        title={highlighted.title[locale]}
        description={highlighted.description[locale]}
        next={`${pathPrefix}/apps/${highlighted.slug}`}
        imageUrl={highlighted.image?.src}
      />
      <ServiceList
        items={context.apps}
        header={serviceList.apps}
        basePath={`${pathPrefix}/apps`}
        dataTestId="landing-service-list"
        includeHighlighted={false}
      />
      {/* Here's the place for the CTA component when we know what should be in there */}
    </Main>
  );
};

const Main = styled.main``;

export default IframeLanding;
